import React, { Component } from "react" 
import { NavLink } from 'react-router-dom'
import TagManager from 'react-gtm-module';
import { Logo, Img } from "../UI/UI";
import { isMobile } from "../../Utility/Utility";
import "./Menu.css";

const appCountrys = [
  {langCode: "de", subDomain: "de", countryName: "Deutsch"},
  // {langCode: "nl", subDomain: "nl", countryName: "Dutch"},
  // {langCode: "at", subDomain: "at", countryName: "Österreich"},
  // {langCode: "pl", subDomain: "pl", countryName: "Polski"},
  // {langCode: "ro", subDomain: "ro", countryName: "Română"},
  // {langCode: "se", subDomain: "se", countryName: "Svenska"},
  // {langCode: "ch", subDomain: "ch", countryName: "Schwyzerdütsch"},
  // {langCode: "cz", subDomain: "cz", countryName: "Cseh"},
  // {langCode: "dk", subDomain: "dk", countryName: "Danish"},
  // {langCode: "hu", subDomain: "hu", countryName: "Magyar"},
  {langCode: "gb", subDomain: "uk", countryName: "English"},
  {langCode: "ru", subDomain: "ru", countryName: "Русский"},
  {langCode: "fr", subDomain: "fr", countryName: "Français"},
  {langCode: "es", subDomain: "es", countryName: "Español"},
  {langCode: "it", subDomain: "it", countryName: "Italiana"},
  {langCode: "eu", subDomain: "eu", countryName: "الإمارات العربية المتحدة"},
  {langCode: "eu-en", subDomain: "eu-en", countryName: "United Arab Emirates"},
  {langCode: "pt", subDomain: "pt", countryName: "Portuguese"},

];

const getParam = window.location.search;

const CurrentFlagIcon = ( props ) => {
  var lang = ( props.lang ) ?  props.lang  : "" ;
  var langName = ( props.langName ) ?  props.langName  : "" ;
  var hideArrow = ( props.hideArrow === true ) ?  true  : false ;

  let arrow = null;

  if ( hideArrow == false ) {
    arrow = <Img desktopImg={'/right-arrow-wb.png'}  cssClass={'bottom-arrow'} />;
  }
  if ( isMobile() ){  
    return(
      <div className="flat-icon-div">
        <div className={'flat-icon-wrapper flat-icon-' + lang} >
          <button onClick={props.setLangState}>
            <Img desktopImg={'/flags/4x3/'+lang+'.svg'}  />
            <div>
              <p>
              {langName}
              </p>
            </div>
            {arrow}
          </button>
        </div>
      </div>
    )
  }else {
    return(
        <div className={'flat-icon-wrapper flat-icon-' + lang} >
          <button onClick={props.setLangState}>
            <Img desktopImg={'/flags/4x3/'+lang+'.svg'}  />
            <div>
              <p>
              {langName}
              </p>
            </div>
            {arrow}
          </button>
        </div>
    );
  }
}

class Menu extends Component {
  state = {
    isOpen : false ,
    isLangOpen: false,
    isNl: false,
    isEn:true
  }

 

  componentDidMount = () => {
    if (getParam === '?lang=nl') {
      this.setState({
        isNl: true
      });
      // console.log('menu isNl1:', this.state.isNl);
    } else if(getParam == '?lang=uk' ){
      this.setState({
        isEn: true
      });
    }
    // console.log('menu isEn2:', this.state.isEn);
  }

  setMenuState = () => {
   if ( this.state.isLangOpen ){    
      this.setState({
        isLangOpen : !this.state.isLangOpen,
        isOpen : !this.state.isOpen
      })
    }else {
      this.setState({
        isOpen : !this.state.isOpen
      })
    }
  } 

  setNl = () => {
    this.setState({
      isNl: true
    });
    // console.log('menu isNl1:', this.state.isNl);
  }
   redirect = (subDomain) => {

     if( (subDomain === "de" ) || (subDomain === "at" )|| (subDomain === "ch" )|| (subDomain === "en" ) || (subDomain === "pl" ) || (subDomain === "it" ) || (subDomain === "es" ) || (subDomain === "ru" ) || (subDomain === "fr" ) || (subDomain === "eu" ) || (subDomain === "eu-en" )){
       
         window.location.href =  'https://new.goisrael.com/' + subDomain;

     } else  if( subDomain === "pt" ){
      window.location.href = 'https://goisrael.com.br/';
     } else {

         window.location.href =  'https://goisrael.com/?lang=' + subDomain;
         // window.location.href =  'http://localhost:3000/?lang=' + subDomain;
     }

     
    if(subDomain == 'nl') {
      this.state.isNl = true;
    } else if (subDomain == '') {
      this.state.isEn = true;
    }
    // console.log('menu isNl2:', this.state.isNl);

             
   }

  setLangState = () => {
    if ( isMobile() ){    
      this.setState({
        isLangOpen : !this.state.isLangOpen,
        isOpen : !this.state.isOpen,
     
      })
    }else {
      this.setState({
        isLangOpen : !this.state.isLangOpen,
      })      
    }
  } 
  render(){

    
    const isLangOpen = this.state.isLangOpen;
    let cssClass ="inner";
     let parentCssClass ="";

    if ( this.state.isOpen === true ) {
      cssClass += " open"
    }

    var countryContainer = null;
    var countryCssClass = 'country-close';

    if ( isLangOpen ) {
        countryCssClass ='country-open'
        countryContainer = appCountrys.map((o) => {
          return  <CurrentFlagIcon lang={o.langCode} langName={o.countryName} setLangState={() => {
            this.redirect(o.subDomain)
          }} hideArrow ={true}  />
                
        })
    }

    var langName = 'UK';
    var langCode = 'gb';
    var CurrentLang = localStorage.getItem('currentLang');
   

    if ( CurrentLang != null ) {
      langName = CurrentLang.toUpperCase();
      if ( CurrentLang == "uk"){
        langCode = 'gb';
      } else {
        langCode = CurrentLang;
      }
   
      
    }

    // alert(langName);

    return(
    <div>
      {this.state.isLangOpen && <div className="nav-trigger-overlay" onClick={this.setLangState}></div>}
      <div className="menu-outer-wrapper">
        <div className="container">
          <div className="col col-15 logo-outer-wrapper">
            <NavLink  exact  className="first" to="/">
              <Logo />
            </NavLink>
          </div>
          <div className="col col-100 menu-inner-wrapper">
            <div className={cssClass}>
              <NavLink  exact  className="first" to={`/${getParam}`} onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'home', }})}>HOME</NavLink>
              {this.state.isNl || this.state.isEn ? <NavLink  exact to={`/Pages/bestDeals${getParam}`} onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'best deals', }})}>BEST DEALS</NavLink> : null}
              <NavLink  exact to={`/Pages/whereToGo${getParam}`} onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'where to go', }})}>WHERE TO GO</NavLink>
              <NavLink  exact to={`/Pages/thingsToDo${getParam}`} onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'things to do', }})}>THINGS TO DO</NavLink>
          
              <NavLink  exact to={`/Pages/Gallery/${getParam}`} onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'gallery', }})}>GALLERY</NavLink>
              <NavLink  exact to={`/Pages/Videos${getParam}`} onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'videos', }})}>VIDEOS</NavLink>
              <NavLink  exact to={`/Pages/TouristInfoPage${getParam}`} onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'main_menu', 'click_cta':'tourist onfo', }})}>TOURIST INFO</NavLink>
              {/*<NavLink  exact to="/Pages/FAQ">FAQ</NavLink>*/}
              <CurrentFlagIcon lang={langCode} langName={langName} setLangState={this.setLangState} hideArrow={false}  />
              
            </div>
            <div className="show-on-mobile">
              <button className="open-mobile-menu navbar-toggle" onClick={this.setMenuState} >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
      <div className={'container country-container '  + countryCssClass}>
          <div className="country-container-inner">
            <div className="country-container-title">
              <h3>  
                Choose your language:
              </h3>
            </div>
            <div className="country-container-flags-wrapper">
              {countryContainer}
            </div>
          </div>
        </div>
        </div>
    )
  }
}


export default Menu


// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js